export const enMessages = {
  undefined: "Undefined",
  moneyUnit: "$",
  millimeter: "mm",
  millionMoneyUnit: "Million Rial",
  pleaseWait: "Please wait",
  pleaseWaitDesignMode: "Saving... Please wait",
  suggestionPrice: "Suggested price",
  typeNumberError: "Only integers allowed",
  wrongPercentage: "Invalid percentage",
  correctFormDataRequired: "Enter valid data",
  all: "All",
  searchGlassProName: "Search glass product",
  selectYaraghBrand: "Select hardware brand",
  minBTmax: "Min must be less than Max",
  noData2Display: "No data available",
  method: "Method",
  coverage: "Coverage",
  sizeMM: "Size (mm)",
  width: "± Width",
  height: "± Height",
  MovableInc: "Movable deduction",
  MovableCount: "Movable count",
  widthRange: "Width range",
  heightRange: "Height range",
  selectedProject: "Selected project",
  selectProject: "Select project",
  home: "Home",
  exit: "Exit",
  createdByUser: "Added by user",
  createdByAdmin: "Added by admin",
  customer: "Customer",
  date: "Date",
  uploadLogo: "Upload logo",
  uploadWaterMark: "Upload watermark",
  ZehvarBaranTowRail: "Double rail",
  ZehvarBaranOneRail: "Single rail",
  ZehvarBaranFixOneRail: "Fixed sash - single rail",
  ZehvarBaranBottom: "Bottom direction",
  ZehvarBaranAll: "All directions",
  Image: "Image",
  Structure: "Structure",
  Select_the_unit: "Select unit",
  ProfileStructure: "Profile structure",
  MeterLong: "Meter length",
  Weighty: "Weight",
  FinalPrice: "Final price",
  Invoice_preview_v2: "Preview",
  Invoice_price_calculation: "Invoice price calculation",
  Invoice_preview: "Invoice preview",
  Invoice_saved_successfully: "Invoice saved",
  Please_select_the_desired_unit: "Select desired unit",
  Profile_charge_manually: "Manual profile charge",
  Calculation_of_the_profile_value_based_on_the_number_of_branches_optimization:
    "Optimize profile value by branches",
  Calculation_of_waste_profile_and_adding_to_the_amount_of_profile:
    "Calculate waste & add to profile",
  percent: "Percent",
  IsCalcPriceUnit: "Apply to base price",
  IsWaterMark: "Has watermark",
  IsIncOtherProfileToMetrajhUnitBUnit: "Miscellaneous profiles are consumed in square footage",
  Select_price_from_archived_invoice: "Select price from archived invoice",
  admin: "Admin",
  user: "User",
  contract_amount_problem: "Contract amount mismatch",
  successfully_registered_contract: "Contract registered",
  number: "Number",
  archive: "Archive",
  new_receipt_register: "New receipt",
  select_invoice: "Select invoice",
  total_received: "Total received",
  remaining: "Remaining",
  byCash: "Cash",
  byCheck: "Check",
  view_payments: "View payments",
  Nothing_found: "Nothing found",
  glass_excel_file: "Glass Excel file",
  graphically: "Graphical",
  linearly: "Linear",
  stickerly: "Sticker",
  excely: "Excel output",
  hinged: "Hinged",
  sliding: "Sliding",
  combinatory: "Combinatory",
  unit_information: "Unit info",
  design_setting_done: "Design settings applied",
  invoice_number: "Invoice number",
  unit_space: "Unit area",
  admin_price: "Admin price",
  user_price: "User price",
  financial_group_price: "Financial price",
  contracted: "Contracted",
  calculate_pr_lo: "Profit/Loss",
  NameGroup: "Group name",
  multiply: "Multiply",
  increase: "Increase",
  decrease: "Decrease",
  relationAlert: "Other items depend on this, resolve dependencies",
  fixer: "Fixer",
  lastik: "Rubber",
  upvc: "UPVC",
  alu: "Aluminum",
  dual_mode: "Dual mode",
  single_mode: "Single mode",
  normal_mode: "Normal",
  window: "Window",
  door: "Door",
  foam: "Foam",
  mastic: "Mastic",
  bank_portal: "Bank portal",
  bank_portal_updating: "Updating bank portal",
  financial_group: "Financial group",
  EnterMobileNumber: "Enter mobile number",
  checkAllFields: "Check all fields",
  invalidNumber: "Invalid number",
  mobileExample: "Example: 09121234567",
  invalidInformation: "Enter valid info",
  enterInformationCorrectly: "Enter requested info correctly",
  enterNewPassword: "Enter new password",
  fromDate: "From date",
  toDate: "To date",
  peroidDetails: "Period details",
  undefinedError: "Unknown error, contact support",
  getDataError: "Data fetch error, try again",
  yes: "Yes",
  addNewUnit: "New unit",
  addNewSquareUnit: "Rectangular",
  addNewNoSquareUnit: "Varied",
  unitList: "Unit list",
  unitList2: "Designed units",
  backToPrj: "Back to projects",
  toolsSideDrawerWarning: "No unit selected",
  invalidAuthCode: "Enter correct auth code",
  enterCode: "Enter SMS code",
  fdpSupport: "Contact us",
  needSupport: "Need support?",
  newCustomer: "New customer",
  repetitiveProject: "Duplicate project",
  select_archived_invoice: "Select archived invoice",
  convertFromToWP: "Convert (@P1) to (@P2)",
  emptyInSelect: "-- Empty --",
  totalPrice: "Total price",
  unitsNumber_renovation_reconstruction: "Units by renovation/reconstruction",
  removed_successfully: "Removed successfully",
  requestedUsersNumberProblem: "Requested users must match or exceed existing",
  pnlChart: "Profit/Loss chart",
  financial_group_admin: "Admin financial group",
  lockedProject: "Project is locked",
  doorWindowCount: "Doors & windows",
  openerSystemiCount: "Systemic openers",
  openerCount: "Openers",
  glassesCount: "Glass count",
  glassSpace: "Glass area",
  netCount: "Net count",
  netSpace: "Net area",
  optimizedProfileBranchMeteringChart: "Optimized profile branch chart",
  optimizedProfileSideWasteAreaDiagram: "Optimized profile & waste chart",
  projectsCount_province: "Projects by province",
  projectsCount_status: "Projects by status",
  unitsCount_hingePattern: "Units by hinge pattern",
  unitsCount_rayleighPattern: "Units by rail pattern",
  unitsCount_frameStructure: "Units by frame structure",
  dunitsCount_renovationReconstructionFrame:
    "Units by renovation/reconstruction frame",
  onReplySMS: "Reply via SMS",
  newTicket: "New ticket",
  createNewTicket: "Create ticket",
  ticketSubset: "Subset",
  ticketDetails: "Ticket details",
  fileDownload: "Download file",
  saveNewMessage: "Write your message...",
  successfullyUserInformationDeleted: "User info deleted",
  sureForDeleteUserInfoWP: "Delete all info of user (@P1)?",
  select: "Select",
  selected: "Selected",
  setAccessLevel: "Set access levels",
  selectAll: "Select all",
  clickToSelectAll: "Select all items",
  sizeLimitWP: "Size must be below [@P1 KB]",
  btnCheckCode: "Check code",
  customPay: "Custom payment",
  customPayPrice: "Custom amount",
  selectedDate: "Previous selected date: ",
  SaveUnitSuccessfully: "Unit saved",
  successfullyEqualGlassOperation: "Glass operation successful",
  successfullyPanelCompletion: "Panel completion successful",
  SlidingToHinge: "Convert sliding to hinge",
  HingedToSliding: "Convert hinge to sliding",
  disableGuideLines: "Disable guide lines",
  enableGuideLines: "Enable guide lines",
  basedOnUserOffers: "Subscription offer packages",
  buyAccount: "Buy account",
  basedOnUserOffersInfo: "Adjust user count or duration as needed.",
  typePriceCalculation: "Price calculation type",
  screenSizeError_1: "Screen too small, use a larger display.",
  screenSizeError_2: "Mobile version coming soon.",
  screenSizeError_3: "Thank you",
  wasCopiedSuccessfully: "Unit copied successfully",
  copyUnit: "Copy unit",
  wasDeletedSuccessfully: "Unit deleted successfully",
  wasEditedSuccessfully: "Unit edited successfully",
  editUnit: "Edit unit",
  FoamMasticUnit: "Foam & mastic unit",
  wasDoneSuccessfully: "Foam & mastic operation successful",
  changeCustomerGroup: "Change customer group",
  invoiceDescription: "Invoice description",
  saveInvoiceDescription: "Save invoice description",
  chargeValue: "Base price charge",
  discountsValue: "Discount values",
  changeCustomerGroupInvoice:
    "Changing customer group updates charge & discount",
  descriptionSavedSuccessfully: "Invoice description saved",
  noEditedItem: "No items to edit",
  newShisheGroup: "New group",
  newShishe: "New glass",
  glassTbl: "Glass products",
  glassEdit: "Edit glass",
  newSpacer: "New spacer",
  spacerTbl: "Spacer products",
  spacerEdit: "Edit spacer",
  customerGroupGetError: "Failed to retrieve customer groups",
  searchProfileCategory: "Search profile category",
  searchProfileTypeColor: "Search profile type & color",
  searchBrandFitting: "Search hardware brand",
  searchPop: "Search opener",
  selectedSeriProfile: "Selected profile series",
  clickToAddProfile: "Click profile series to add category",
  m2: "m²",
  useSearchBtn: "Use search button",
  netIncWH: "Increase/decrease relative to sash",
  netMovable: "Movable property",
  invoiceTitle: "Invoice title",
  invoiceTitlePre: "Pre-invoice",
  invoiceTitleMain: "Invoice",
  unitSearch: "Search unit",
  needDescription: "Enter a description for your file",
  sendMSG: "Send message",
  closedTicket: "This ticket is closed. Open a new one if needed",
  closedTicketAdmin: "Ticket closed",
  changeTicketToClose: "Change status to closed",
  changeTicketToChecking: "Change status to reviewing",
  preInvoiceTitle: "Pre-invoice title",
  identificationCode: "Referral code",
  loadMore: "Load more",
  loadUnitCount: "Unit count",
  loadUnitCountDetail: "@P1 of @P2",
  unitDetails: "Unit details",
  _count: "Count",
  factorPreventEntry_1: "You don't have access to this section",
  factorPreventEntry_2: "Contact your system admin for details",
  selectedUnitCount: "Selected units count",
  discountCharge: "Discount & base price increase",
  factorDisplaySetting: "Invoice display settings",
  noWrite: "Not written",
  notCalculated: "Not calculated",
  setSelected: "Select",
  projectsListMenu: "Project list",
  backMenu: "Back menu",
  noSelectedProperties: "Select a section to view details",
  deleteUnit: "Delete unit",
  addButtonFastMode: "Quick mode",
  addButtonNormalMode: "Normal mode",
  unitShape: "Unit shape",
  unitWidth: "Unit width",
  unitHeight: "Unit height",
  payment_reference_number: "Reference number",
  payment_tracking_number: "Tracking number",
  payment_error: "Bank transaction error",
  payment_problem: "Transaction issue occurred",
  payment_tryAgain: "Try again in a few minutes",
  payment_BackMobile: "Return to mobile app",
  payment_choosing: "Thanks for choosing us",
  payment_transferring: "Redirecting to payment gateway...",
  wrong_address: "Incorrect address. Contact support",
  supported_site: "Redirecting to support site",
  customer_registration: "Register customer",
  customer_registration_exp: "Register customers before adding projects",
  customer_registration_section: "Go to customers",
  customer_project: "New project",
  customer_project_exp: "Manage projects, invoices, reports & contracts",
  customer_project_section: "Go to projects",
  default_project_has_Another: "Another project added to default project list",
  windWidthError: "Gap width must not be within unit width",
  windHeightError: "Gap height must not be within unit height",
  isPeriod: "Default",
  dimensionsError: "Invalid dimensions",
  dimensionsLimitationError: "Ignoring technical dimension limits",
  patternNotSelected: "Pattern not selected",
  glassWallError: "Glass layer mismatch with beading",
  panelCompletion: "Panel completion",
  expiryCreditDate: "Expiration date",
  RemainingTime: "Remaining time",
  month: "Month",
  day: "Day",
  hour: "Hour",
  minute: "Minute",
  haveDiscountCode: "Do you have a discount code?",
  enterDiscountCode: "Enter discount code",
  priceCalculation: "Price calculation",
  viewDetails: "View details",
  periodDetails: "Subscription renewal details",
  totalAmounts: "Total amounts",
  totalPayment: "Total payment",
  totalTax: "Total tax",
  paymentCalcInfoPage: "Press 'Calculate Price' to view total payment",
  walletBalance: "Wallet balance",
  activeUsersCount: "Active users",
  validityPeriod: "Validity period",
  currentPeriod: "Current period",
  paymentsHistory: "Payments & invoices",
  periodName: "Period name",
  activeUsers: "Active users in this period",
  transaction_error: "Bank transaction error! Try again later.",
  successfulPayment: "Payment successful",
  referenceNo: "Reference No: ",
  issueTracking: "Tracking No: ",
  increaseUserDetails: "View user increase details",
  addUserCalculatedPrice: "Price based on remaining service time",
  increaseWalletSuggestions: "Special offers",
  payableAmount: "Payable amount",
  receivedAmount: "Received credit",
  expiredPanel: "Your panel has expired",
  contactSalesDepartment: "Contact sales department",
  contactAdminDepartment: "Contact system admin",
  thanks: "Thank you",
  purchaseDetails: "View purchase details",
  enter_username: "Enter username",
  enter_password: "Enter password",
  enter_amount: "Enter amount",
  enter_amount_WID: "Enter @S1",
  not_contain_number_in_first: "Names can't start with numbers",
  only_English_letters: "Only English letters & numbers allowed",
  Error_amount_validation: "Amount validation error",
  not_zero: "Enter a number other than zero",
  invalidEmail: "Invalid email",
  minimum_char_WID: "Minimum @S1 characters",
  maximum_char_WID: "Maximum @S1 characters",
  minimum_value_WID: "Minimum value: @S1",
  maximum_value_WID: "Maximum value: @S1",
  invalidMobile: "Invalid mobile number",
  minimum_decimal_WID: "Up to @S1 decimal places allowed",
  invalidDecimalFormat: "Invalid decimal format",
  mission_accomplished: "Operation successful",
  changePriceSuccess: "Price updated successfully",
  The_editing_of_foam_and_mastic_was_done_successfully: "Foam & mastic edited",
  The_new_foam_and_mastic_was_successfully_registered:
    "New foam & mastic added",
  Foam_and_mastic_were_successfully_removed: "Foam & mastic removed",
  Successfully_added_spacer: "Spacer added",
  Spacer_edited_successfully: "Spacer edited",
  The_spacer_was_successfully_removed: "Spacer removed",
  Glass_successfully_added: "Glass added",
  Glass_edited_successfully: "Glass edited",
  The_glass_was_successfully_removed: "Glass removed",
  Glass_group_added_successfully: "Glass group added",
  Glass_group_edited_successfully: "Glass group edited",
  Glass_group_was_successfully_removed: "Glass group removed",
  Glass_product_added_successfully: "Glass product added",
  The_glass_product_was_edited_successfully: "Glass product edited",
  The_glass_product_was_successfully_removed: "Glass product removed",
  The_net_price_was_successfully_edited: "Net price updated",
  Torry_edited_successfully: "Net edited",
  Lace_added_successfully: "Net added",
  Tori_removed_successfully: "Net removed",
  changeWeightSuccess: "Weight updated",
  settings_saved_successfully: "Settings saved",
  profile_category_deleted_successfully: "Profile category removed",
  successfully_activated: "Activated",
  successfully_disabled: "Disabled",
  profile_handle_updated_successfully: "Profile category updated",
  profile_category_successfully_added: "Profile category added",
  name_edited_successfully: "Name updated",
  profile_color_added_successfully: "Profile color added",
  profile_type_added_successfully: "Profile type added",
  profile_color_was_successfully_deleted: "Profile color deleted",
  profile_color_successfully_disabled: "Profile color disabled",
  profile_type_deleted_successfully: "Profile type deleted",
  profile_type_successfully_deactivated: "Profile type deactivated",
  successfully_edited_crop_fraction: "Crop fraction updated",
  group_price_change_successfully: "Group price updated",
  color_disabled: "Color disabled",
  color_activated: "Color activated",
  color_type_disabled: "Color type disabled",
  color_type_enabled: "Color type enabled",
  Rokub_editing_was_done_successfully: "Beading edited",
  New_Roku_was_registered_successfully: "New beading added",
  The_tracking_was_successfully_removed: "Beading removed",
  Rocube_has_been_successfully_disabled: "Beading disabled",
  The_new_service_was_successfully_registered: "New service added",
  Service_edited_successfully: "Service edited",
  The_service_was_successfully_removed: "Service removed",
  Hardware_brand_added_successfully: "Hardware brand added",
  Opener_successfully_added: "Opener added",
  Brand_added_successfully: "Brand added",
  Hardware_has_been_cleared_successfully: "Hardware cleared",
  The_popup_was_successfully_removed: "Opener removed",
  Range_Cleared_Successfully: "Range cleared",
  Editing_the_hardware_range_was_successful: "Hardware range edited",
  New_range_successfully_added: "New range added",
  password_change_successfully: "Password changed successfully",
  registered_successfully: "Info saved. Login details sent via SMS",
  Customer_added_successfully: "Customer added",
  The_client_was_successfully_deleted: "Customer deleted",
  Customer_information_successfully_edited: "Customer info updated",
  Customer_group_added_successfully: "Customer group added",
  Customer_group_edited_successfully: "Customer group updated",
  Customer_group_deleted_successfully: "Customer group deleted",
  Template_added_successfully: "Template added",
  Pattern_deleted_successfully: "Template deleted",
  The_template_was_edited_successfully: "Template updated",
  Project_successfully_added: "Project added",
  Project_deleted_successfully: "Project deleted",
  Project_information_edited_successfully: "Project info updated",
  Production_settings_successfully_completed: "Production settings saved",
  Financial_settings_completed_successfully: "Financial settings saved",
  User_edited_successfully: "User updated",
  User_deleted_successfully: "User deleted",
  User_group_added_successfully: "User group added",
  User_group_edited_successfully: "User group updated",
  User_group_deleted_successfully: "User group deleted",
  unit_images: "Unit images",
  QC_prj_Label: "Project QC label",
  QC_glass_Label: "Glass QC label",
  QC_ProductionCardWithDetails: "Production card with details",
  QC_LargerUnitImages: "Larger unit images",
  general_consumable: "General consumables",
  per_unit_consumable: "Unit-specific consumables",
  general_fittings: "General hardware",
  per_unit_fittings: "Unit-specific hardware",
  technical_fittings: "Technical hardware",
  isOther: "Additional items",
  isFrame: "Frame",
  isSash: "Sash",
  isSashDoor: "Sash door",
  isMullion: "Mullion",
  isMulion: "Mullion",
  isGlazing: "Beading",
  isRokob: "Beading",
  isInterLock: "Interlock",
  isConectorSash: "Sash connector",
  isOtherPop: "Other hinged items",
  isOtherRail: "Other sliding items",
  isPanel: "Panel",
  isProfileKomaki: "Auxiliary profile",
  thickness: "Thickness",
  brandName: "Brand name",
  weight: "Weight",
  ProfileTypeList: "Profile type list",
  ProfileCatName: "Profile category",
  moveHandlePlace: "Move handle position",
  payment: "Payment",
  upload: "Upload file",
  selectedFile: "Selected file",
  notSelectedFile: "No file selected",
  ticket_details: "Ticket details",
  read: "Read",
  unread: "Unread",
  isDelete: "Deleted",
  messageDate: "Message date",
  fileAttachment: "File attachment",
  viewFile: "View file",
  describe: "Description",
  history_payments: "Payment history",
  history_details: "Subscription history",
  profit_and_loss_of_the_project: "Project profit/loss",
  profit_and_loss_list: "Profit/loss list",
  calculation_of_profit_and_loss: "Profit/loss calculation",
  calculate_based: "Calculate based on amount",
  price_factor: "Invoice amount",
  tax: "Tax",
  profitProfile: "Profile profit",
  profitFitting: "Fitting profit",
  profitGlass: "Glass profit",
  profitNet: "Net profit",
  profitOther: "Other profit",
  profitService: "Service profit",
  arcCost: "Arc cost",
  angleCost: "Angle cost",
  calculation: "Calculation",
  notification: "Messages",
  notifications_list: "Message list",
  title: "Title",
  ticketGroup: "Subgroup",
  tickets: "Tickets",
  support: "Support",
  tickets_list: "Ticket list",
  history: "History",
  history_list: "Period history",
  units: "Units",
  FormContract: "Contract",
  form_add_user: "Add user",
  current_term_renewal_form: "Renew current period",
  panel_information: "Account recharge management",
  wallet: "Wallet",
  purchase_form: "Purchase",
  handlePlace: "Handle position",
  glassFontSize: "Glass font size",
  description: "Description",
  payDescription: "Payment description",
  contractDescription: "Contract description",
  usingTime: "Usage time",
  numberUsers: "Number of users",
  paymentType: "Select payment method",
  paymentType2: "Payment method",
  amountPaid: "Amount paid",
  paymentDocument: "Document number",
  bank: "Bank",
  branch: "Branch",
  contractNumber: "Contract number",
  button_save: "Save",
  register: "Complete registration",
  sent_code: "Code sent",
  name_company: "Workshop name",
  unique: "Unique name",
  stateProject: "Period",
  number_of_customers: "Number of customers",
  number_of_projects: "Number of projects",
  number_of_factors: "Number of invoices",
  print: "Print",
  save: "Save invoice",
  leafCount: "Leaf count",
  template: "Template",
  editProject: "Edit project",
  state: "Status",
  sysGroup: "Calculation method",
  windGapWidth: "Gap width",
  sendVerificationCode: "Send verification code",
  createNewProject: "New project",
  statusHistory: "Status history",
  determineStatusProject: "Set project status",
  searchNameCode: "Search by name/code",
  manageProjects: "Manage projects",
  printInvoice: "Print invoice",
  cost: "Cost",
  display: "Display",
  factorArchive: "Invoice archive",
  shippingCost: "Shipping cost",
  arc: "Arc",
  angles: "Angle",
  installationCost: "Installation cost",
  otherCost: "Additional cost",
  consumedMaterialCost: "Material cost",
  discountAmount: "Discount after tax",
  materials: "Production items",
  discount: "Discount",
  basePriceDiscount: "Base price discount",
  basePriceCharge: "Base price increase",
  pricing: "Pricing",
  lengthLessThan: "Side length below this size is waste",
  casementSystem: "Hinged system",
  slidingSystem: "Sliding system",
  chargeConsumedMaterial: "Increase material usage",
  invoiceSetting: "Invoice settings",
  priceSetting: "Price settings",
  pricingMethod: "Profile pricing method",
  typeInvoice: "Invoice display type",
  listItems: "Unit list",
  selectProfile: "Profile components",
  barLength: "Branch length",
  selectPiecesGroup: "Item group",
  resend: "Resend",
  send: "Send",
  twoStepLogin: "Two-step login",
  shopPanel: "Shop Panel",
  delete: "Delete",
  IsShowNameProjectOptimal: "Project name",
  IsShowNameUnitOptimal: "Unit name",
  IsShowCoverWaterOptimal: "Water cover",
  IsShowHandleOptimal: "Handle",
  IsShowLolaOptimal: "Hinge",
  CoverWaterFrame: "Frame cover",
  CoverWaterMulion: "Mullion cover",
  CoverWaterTop: "Top cover",
  CoverWaterbot: "Bottom cover",
  optimization: "Optimization",
  locationCover: "Cover location",
  railChannelCoverProfile: "Rain beading",
  requestChangeStatus: "Change status",
  thresholdBottom: "Threshold to floor distance",
  thresholdTop: "Threshold to height distance",
  couple: "Couple",
  glazing: "Beading",
  glassGroup: "Glass group",
  brand: "Brand",
  pop: "Opener",
  consumedFoam: "Foam used",
  consumedMastic: "Mastic used",
  nameUnit: "Unit name",
  ـnameUnit: "Unit name",
  placeLocation: "Installation location",
  numberUnit: "Number of units",
  superVisor: "Supervisor",
  agent: "Agent",
  groupedAgents: "Grouped agents",
  unGroupedAgents: "Ungrouped agents",
  factors: "Invoices",
  User_Supervisor_Replace: "Replace supervisor:",
  User_Supervisor_Group: "Group",
  Manage_User_Supervisor: "Manage supervisors",
  priceProfile: "Profile price",
  priceGlass: "Glass price",
  priceNet: "Net price",
  priceOther: "Other price",
  priceFitting: "Fitting price",
  parts: "Components",
  CheckTell: "Phone",
  CheckAddress: "Address",
  CheckWeb: "Website",
  CheckEmail: "Email",
  CheckLogo: "Logo",
  CheckHeader: "Header",
  CheckFooter: "Footer",
  WaterMark: "Watermark",
  CheckHeaderSlogan: "Company slogan",
  userAccessFactor: "Invoice access level",
  count: "Count",
  windGapHeight: "Gap height",
  location: "Installation location",
  services: "Services",
  Spicer: "Spacer",
  GroupGlass: "Glass group",
  ProductGlass: "Glass product",
  FoamMastic: "Foam & mastic",
  SeriProfile: "Profile series",
  Khadmat: "Services",
  Setting: "Settings",
  Flashing: "Beading",
  FixerLastic: "Fixer rubber",
  deleteInfo: "Delete info",
  Workshop: "Production",
  TypeColor: "Color group",
  Template: "Template",
  Statistics: "Statistics",
  ChangeStateProject: "Change project status",
  EditUserAccess: "User access level",
  profit: "Profit & loss",
  contract: "Contract",
  Show: "Show",
  Delete: "Delete",
  Edit: "Edit",
  Register: "Register",
  Price2: "User price",
  WorkShop: "Workshop",
  CutGlass: "Glass report",
  production: "Production",
  Factor: "Invoice",
  Designer: "Design",
  GroupCustomer: "Customer",
  value: "Value",
  unitPrice: "Unit price",
  bottom_jamb: "Bottom jamb",
  lifting_profile: "Lifting profile",
  threshold: "Threshold",
  flashing: "Beading",
  fitScreen: "Positioning",
  equalGlass: "Equal glass",
  coverWater: "Water channel cover",
  edit_pattern: "Edit template",
  others: "Others",
  zehvar: "Beading",
  panel: "Panel",
  sash_door: "Sash door",
  frame: "Frame",
  sash: "Sash",
  mulion: "mullion",
  preview: "Preview report",
  download: "Download",
  disable: "Disable",
  unchangeable: "Unchangeable",
  construction: "Construction",
  active: "Active",
  spacer: "Spacer",
  tanzimatGozareshatMali: "Invoice",
  tanzimatGozareshatTolide: "Production",
  tanzimatTarahi: "Design",
  tanzimatShop: "Shop",
  name: "Name",
  shomareEghtesadi: "Tax ID",
  mobile: "Mobile",
  telephone: "Phone",
  last_Name: "Full name",
  fax: "Fax",
  customerGroup: "Customer group",
  customerGroups: "Customer groups",
  ostan: "Province",
  city: "City",
  address: "Address",
  chargeOther: "Other charge",
  discountOther: "Other discount",
  displayName: "Full name",
  email: "Email",
  group: "Group",
  stypePanel: "Stype Panel",
  phoneNumber: "Phone number",
  userName: "Username",
  password: "Password",
  Other: "Other",
  Service: "Service",
  moshtari_jadid: "New customer",
  groh_moshtari: "Customer group",
  list_rokob: "Beading list",
  list_Khadmat: "Services list",
  list_FomMastik: "Foam & mastic list",
  moshtari: "Customer",
  list_moshtari: "Customer list",
  virayesh: "Edit",
  virayesh_moshtari: "Edit customer",
  sakht_groh_jadid: "Create new group",
  newCustomerGroup: "Create new customer group",
  newUserGroup: "Create new financial group",
  name_groh_jadid: "Group name",
  convertGroup: "Group conversion",
  convertFrom: "Convert from",
  convertTo: "Convert to",
  unit_convert: "Temporary unit conversion",
  unit_convert2: "Permanent unit conversion",
  convertProfile: "Select components",
  darsad_sharj: "Charge percentage",
  darsad_takhfif: "Discount percentage",
  ezafe_be_list: "Add to list",
  add_project_to_list: "Add project to list",
  ble_pak_shavad: "Yes, delete",
  enseraf: "Cancel",
  aya_az_hazf_an_etminan_darid: "Are you sure you want to delete?",
  did_you_receive_text_message: "Resend code?",
  welcome_software: "Welcome to Dorsawin",
  please_wait_to_receive_the_verification_code:
    "Waiting for verification code...",
  hazf: "Delete",
  list_karbaran: "User list",
  moderiyat_karbaran: "User management",
  karbar_jadid: "New user",
  groh_mali_karbaran: "Financial user group",
  ejad_hesab_karbari_jadid: "Create new user account",
  Manage_User: "Manage users",
  customerGroupMali: "Customer financial group",
  list_olgo: "Template list",
  select_olgo: "Select template",
  list_shishe: "Glass products list",
  list_tori: "Net list",
  list_yaragh: "Commercial range list",
  list_Fani: "Technical range list",
  MahdoodeFani: "Technical range",
  MahdoodeYaragh: "Commercial range",
  yaraghProductList: "Products list",
  standardCode: "Standard code",
  partCount: "Quantity",
  stuffAx: "Axis",
  stuffSide: "Direction",
  stuffColor: "Color",
  stuffLevelSecurity: "Security level",
  newStuff: "New product",
  editStuff: "Edit product",
  addNewStuff: "Add product",
  add_new_stuff: "Product added successfully",
  edit_stuff: "Product updated",
  remove_stuff: "Product deleted",
  edit_stuffCount: "Edit quantity",
  copy_product: "Copy product",
  copy_product_successfully: "Product copied",
  copy_product_to: "Copy to",
  same_source_and_destination: "Source and destination must be different",
  list_profile: "Profile specs list",
  profileSeries: "Profile series",
  close: "Close",
  profile_category_archive: "Profile series archive",
  fixer_and_rubber_pricing: "Fixer & rubber pricing",
  profileTypeColor: "Profile type & color",
  profileCategory: "Profile series",
  newProfileTypeColor: "New profile type & color",
  listColors: "Color list",
  profileTypeColorSetting: "Profile type & color settings",
  Reinforcement_cutting_decrease_setting: "Reinforcement cutting reduction",
  total: "Enter value",
  isPercent: "Is percent",
  changeType: "Change type",
  typesList: "Profile types",
  colorList: "Profile colors",
  nameBrand: "Search brand",
  nameSearch: "Search name",
  usernameSearch: "Search username",
  keshvar: "Country",
  country: "Country",
  selectType: "Select type",
  struct: "Material",
  zobFrame: "Frame melting",
  zobSash: "Sash melting",
  sarboreshMolion: "Mullion cut",
  sarboreshMolionKatibe: "Mullion inscription cut",
  fazayeAzadAverhung: "Overhang free space",
  badkhorFrameSash: "Glass gap (Frame/Sash)",
  badkhorMolion: "Glass gap (Mullion)",
  hampushaniW: "Width overlap",
  virayesh_Olgu: "Edit template",
  hampushaniH: "Height overlap",
  hampushaniKaman: "Arc overlap",
  sizeDarpush: "Overhang cover size",
  badkhorPanelFrame: "Panel gap (Frame/Sash)",
  badkhorPanelMolion: "Panel gap (Mullion)",
  IncArcFrame: "Arc increment (Frame)",
  IncArcSash: "Arc increment (Sash)",
  IncArcGlazing: "Arc increment (Glazing)",
  IsZehvar90: "90-degree beading cut",
  fomMastikType: "Foam/Mastic type",
  nameType: "Profile type",
  nameColor: "Color name",
  dasteProfile: "Profile series",
  newPattern: "New template",
  searchProfileCategories: "Search profile series",
  type: "Type",
  typeColor: "Profile type",
  color: "Color",
  brandYaragh: "Hardware brand",
  shisheGroup: "Glass group",
  sashDoor: "Sash door",
  overhung: "Overhang",
  profileKomaki: "Auxiliary profile",
  zehvar1: "Single-layer beading",
  zehvar2: "Double-layer beading",
  zehvar3: "Triple-layer beading",
  brandFitting: "Hardware brand",
  molionKatibeh: "Inscription mullion",
  molionFrame: "Frame mullion",
  interLock: "Interlock",
  conectorSash: "Sash connector",
  zehvarBaran: "Rain beading",
  status: "Status",
  newNet: "New net",
  addNewNet: "Add new net",
  other: "Other",
  service: "Service",
  displayUser: "Full name",
  userGroup: "User group",
  userGroups: "Financial user groups",
  stypeUser: "User role",
  virayesh_users: "Edit users",
  mahdoodeName: "Range name",
  priceMahdoode: "Price",
  yaraghBrand: "Hardware brand",
  archiveFittingBrand: "Hardware brand archive",
  yaraghName: "Hardware brand",
  priceTori: "Price",
  price: "Price",
  halatBazsho: "Opener mode",
  bazshoName: "Opener name",
  addNewPop: "Add new opener",
  addNewBrandFitting: "Add new hardware brand",
  editBrandFitting: "Edit hardware brand",
  editBazshoFitting: "Edit opener name",
  successfullyEditBazshoFitting: "Opener name updated",
  priceChangeInGroup: "Group price change",
  minW: "Min width",
  maxW: "Max width",
  maxH: "Max height",
  minH: "Min height",
  virayesh_MahdoodeYaragh: "Edit hardware range",
  newAccessoryRange: "New commercial range",
  newAccessoryRangeFani: "New technical range",
  MahdoodeFaniProductManagement: "Manage products",
  addNewAccessoryRange: "Add new hardware range",
  typeGroup: "Select type",
  spacer_manage: "Spacer details",
  glass_manage: "Glass details",
  glass_group_manage: "Glass group management",
  new_glass_product: "New glass product",
  edit_glass_product: "Edit glass product",
  jedare: "Layer",
  nameshishe: "Glass name",
  spacerName: "Spacer name",
  thick: "Thickness",
  shisheName: "New glass name",
  shisheGroupName: "Glass group name",
  editShisheGroup: "Edit glass group",
  nameRokub: "Beading name",
  newService: "New service",
  addNewService: "Add new service",
  priceRokub: "Price",
  nameFomMastik: "Foam & mastic name",
  newFomMastik: "New foam & mastic",
  newFlashing: "New beading",
  addNewFlashing: "Add new beading",
  addNewFomMastik: "Add new foam & mastic",
  cover: "Coverage per meter",
  priceFomMastik: "Price",
  calculationType: "Calculation method",
  titleService: "Service title",
  priceService: "Price",
  virayesh_Khedmat: "Edit services",
  groupPrice: "Admin price",
  userPrice: "User price",
  virayesh_FomMastik: "Edit foam & mastic",
  virayesh_Rokub: "Edit beading",
  virayesh_tori: "Edit net",
  incW: "± Sash width",
  incH: "± Sash height",
  glassCalc: "Min glass size",
  netCalc: "Min net size",
  costArc: "Arc production cost",
  costAngle: "Angle production cost",
  header: "Header text",
  headerSlogan: "Company slogan",
  tell: "Phone number",
  phone: "Phone number",
  web: "Website",
  footer: "Footer text",
  zakhirTanzimatMali: "Save invoice settings",
  financialReportSettings: "Invoice settings",
  productionReportSettings: "Production settings",
  designSettings: "Design settings",
  shopSettings: "Shop settings",
  unitName: "Design name",
  breakW: "Unit width gap",
  breakH: "Unit height gap",
  sizeFontDesigner: "Design font size",
  limitCouple: "Allowed couple spacing",
  limitMulion: "Allowed mullion spacing",
  limitGuidLine: "Guide line spacing",
  zakhire_tanzimat_tarahi: "Save design settings",
  bladeThickProfile: "Profile blade thickness",
  bladeThickGalvanize: "Galvanized blade thickness",
  wasteSizeProfile: "Profile waste size",
  wasteSizeGalvanize: "Galvanized waste size",
  glassFixer: "Fix glass count",
  bazsho: "Opener glass count",
  countMinScrewIron: "Min screw size (galvanized) 2 pcs",
  countBetweenScrowIron: "Screw spacing (galvanized)",
  minOneCoveWater: "Min one water cover",
  maxOneCoveWater: "Max one water cover",
  minTwoCoveWater: "Min two water covers",
  maxTwoCoveWater: "Max two water covers",
  zakhireTanzimatTolid: "Save production settings",
  projectName: "Project name",
  project_name_input: "Enter project name",
  maliyat: "Tax",
  nasb: "Installation",
  mavadMasrafi: "Consumables",
  projectsList: "Project list",
  virayesh_project: "Edit project details",
  projectStatus: "Project status",
  Appendix: "Appendix",
  projects: "Projects",
  design: "Design",
  invoices: "Invoices",
  customers: "Customers",
  customers_name_input: "Select customer",
  properties: "Properties",
  patterns: "Patterns",
  patternsGroup: "Patterns Group",
  users: "Users",
  settings: "Settings",
  button_register_password: "Set new password",
  header_welcome: "Welcome to WebWin",
  header_enter_your_information_to_enter_the_panel:
    "Enter your details to log in",
  input_userName: "Username",
  input_password: "Password",
  button_forgot_password: "Forgot password?",
  button_return_login: "Back to login",
  button_login: "Login",
  button_signup: "Sign up (free)",
  button_send_code: "Send code",
  header_password_recovery: "Password recovery",
  input_phone: "Mobile number",
  err_emailIsNull: "Enter your email",
  err_mobileIsNull: "Enter your mobile number",
  err_mobileNotValid: "Invalid mobile number",
  err_emailNotValid: "Invalid email",
  err_isNull: "Field is empty",
  olgo: "Template",
  rokob: "Beading",
  va: "and",
  nameProfile: "Profile name",
  size: "Size",
  sizeV2: "Dimensions (mm)",
  gheimat: "Price",
  moratabSazi: "Sorting",
  astaneVaPakhor: "Threshold & bottom jamb",
  sabtenam: "Create account",
  user_Account: "User account",
  resetPassword: "Reset password",
  Shomare: "Code",
  taeed: "Confirm",
  fullName: "Full name",
  newPassword: "New password",
  oldPassword: "Old password",
  vaziyat: "Status",
  faal: "Active",
  gheirFaal: "Blocked",
  zakhire: "Save",
  _zakhire: "Save design",
  ezafeKardan: "Add",
  fullscreen: "Fullscreen",
  ListBoresh: "Cutting list",
  behinehSaziGalvanize: "Galvanized optimization",
  AglamMasrafi: "Consumable items",
  controlkeyfiat: "Quality control",
  accountDarid: "Already have an account?",
  noDataText: "No data available",
  _noDataText: "No information",
  sharayeteEstefadeAzKhadamat: "Terms of service",
  faalYaMasdood: "Activate or block user?",
  etminanHazf: "Are you sure you want to delete this user?",
  brand_name: "Dorsawin",
  statistic: "Statistics",
  statotal: "Overall stats",
  groupProfile: "Profile category",
  period: "Time range",
  filter: "Filter",
  backToList: "Back to list",
  acceptance_rules_p1: "WebWin privacy policy",
  acceptance_rules_p2: "I have read and accept all terms.",
  share: "Share",
  moreInfoInShare: "Generated in WebWin software",
  share_success: "File sent",
  share_error: "File not sent",
  share_device_notCompatible: "Browser cannot send files",
  search: "Search",
  newProjectAddressInfo: "Enter project address:",
  notSelected: "Not selected",
  selectOneItem: "Select one item",
  newNotification: "New message received",
  priceNotEntered: "Price not entered",
  customer_edit_custom_charge: "Edit custom charge for this category",
  customer_edit_custom_discount: "Edit custom discount for this category",
  customer_apply_custom_charge: "Apply custom charge to this category",
  customer_apply_custom_discount: "Apply custom discount to this category",
  bankProblem: "Payment gateway updating",
  up: "above",
  down: "below",
  stfh_adjustment: "Sink, threshold, footrest and height adjustment",
  elevation_direction: "Direction of the elevation",
  select_one_above_below: "Above or below ?",
  bottom_footrest_length: "Bottom footrest length",
  threshold_location: "Threshold location",
  accordion_Settings: "Accordion Settings",
  accordion: "Accordion",
  clickToSelectDesiredLocation: "Please click on the desired location to place the accordion",
  dropdown_not_defined: "No corresponding dropdown has been defined for this hardware brand.",
  drawerLock: "Drawer Lock",
  SaveUnitOrderSuccessfully: "Sort changes saved successfully",
  unitReorder: "Unit Reorder",
  priceWithTax: "The amount paid includes VAT",
  designerBreakFrameDialog: "Profile Stitching",
  designerBreakFrame: "Sewing Location",

  //todo [Tools Side Drawer]
  tool_side_drawer_Select: "Select",
  tool_side_drawer_Clear: "Clear",
  tool_side_drawer_Vertical_connection: "Vertical connection",
  tool_side_drawer_Horizontal_connection: "Horizontal connection",
  tool_side_drawer_Vertical_mullion: "Vertical mullion",
  tool_side_drawer_Horizontal_mullion: "Horizontal mullion",
  tool_side_drawer_Horizontal_divider: "Horizontal divider",
  tool_side_drawer_Vertical_divider: "Vertical divider",
  tool_side_drawer_Full_mullion: "Full-length mullion",
  tool_side_drawer_Transom_mullion: "Transom mullion",
  tool_side_drawer_Single_wl: "Single-mode left-opening window",
  tool_side_drawer_Single_wr: "Single-mode right-opening window",
  tool_side_drawer_Dual_wl: "Dual-mode left-opening window",
  tool_side_drawer_Dual_wr: "Dual-mode right-opening window",
  tool_side_drawer_oTop: "Top-opening window",
  tool_side_drawer_oBottom: "Bottom-opening window",
  tool_side_drawer_Volkswagen: "Volkswagen",
  tool_side_drawer_French_window: "French window",
  tool_side_drawer_Single_dl: "Single-mode left-opening door",
  tool_side_drawer_Single_dr: "Single-mode right-opening door",
  tool_side_drawer_Dual_door: "Dual-mode door",
  tool_side_drawer_French_door: "French door",
  tool_side_drawer_Accordion: "Accordion",
  tool_side_drawer_Single_2s: "Single-track sliding with two sashes",
  tool_side_drawer_Single_3s: "Single-track sliding with three sashes",
  tool_side_drawer_Single_4s: "Single-track sliding with four sashes",
  tool_side_drawer_Double_2s: "Double-track sliding with two sashes",
  tool_side_drawer_Double_3s: "Double-track sliding with three sashes",
  tool_side_drawer_Double_4s: "Double-track sliding with four sashes",
  tool_side_drawer_Triple_3s: "Triple-track sliding with three sashes",
  tool_side_drawer_Triple_5s: "Triple-track sliding with five sashes",
  tool_side_drawer_Triple_6s: "Triple-track sliding with six sashes",
  tool_side_drawer_Quad_4s: "Quad-track sliding with four sashes",
  tool_side_drawer_Quad_6s: "Quad-track sliding with six sashes",
  tool_side_drawer_Quad_7s: "Quad-track sliding with seven sashes",
  tool_side_drawer_Quad_8s: "Quad-track sliding with eight sashes",
  tool_side_drawer_sash_net: "Fixed sash with net",
  tool_side_drawer_Net: "Net",
  tool_side_drawer_FixedSash: "Fixed sash",
  tool_side_drawer_Panel: "Panel",
  tool_side_drawer_Beading: "Beading, threshold, bottom jamb, and height extender",

  //todo [Shapes List]
  Rectangle: "Rectangle",
  Two_rectangles_inside_each_other_1: "Two rectangles inside each other 1",
  Two_rectangles_inside_each_other_2: "Two rectangles inside each other 2",
  Two_rectangles_inside_each_other_3: "Two rectangles inside each other 3",
  Two_rectangles_inside_each_other_4: "Two rectangles inside each other 4",
  Horizontal_eye: "Horizontal eye",
  Vertical_eye: "Vertical eye",
  Two_bent_corners_1: "Two bent corners 1",
  Two_bent_corners_2: "Two bent corners 2",
  Two_bent_corners_3: "Two bent corners 3",
  Two_bent_corners_4: "Two bent corners 4",
  Two_bent_corners_u4: "Two bent corners u4",
  Two_bent_corners_u1: "Two bent corners u1",
  Two_bent_corners_u3: "Two bent corners u3",
  Two_bent_corners_5: "Two bent corners 5",
  Two_bent_corners_j1: "Two bent corners j1",
  Two_bent_corners_j2: "Two bent corners j2",
  Two_diagonal_corners_1: "Two diagonal corners 1",
  Two_diagonal_corners_2: "Two diagonal corners 2",
  Two_diagonal_corners_3: "Two diagonal corners 3",
  Two_diagonal_corners_4: "Two diagonal corners 4",
  Horizontal_trapezoid_1: "Horizontal trapezoid 1",
  Horizontal_Trapezoid_2: "Horizontal Trapezoid 2",
  Horizontal_Trapezoid_3: "Horizontal Trapezoid 3",
  Horizontal_Trapezoid_4: "Horizontal Trapezoid 4",
  Vertical_Trapezoid_1: "Vertical Trapezoid 1",
  Vertical_Trapezoid_2: "Vertical Trapezoid 2",
  Vertical_Trapezoid_3: "Vertical Trapezoid 3",
  Vertical_Trapezoid_4: "Vertical Trapezoid 4",
  Isosceles_Trapezoid_1: "Isosceles Trapezoid 1",
  Isosceles_Trapezoid_2: "Isosceles Trapezoid 2",
  Isosceles_Trapezoid_3: "Isosceles Trapezoid 3",
  Isosceles_Trapezoid_4: "Isosceles Trapezoid 4",
  Various_Sided_Trapezoid_1: "Various Sided Trapezoid 1",
  Various_Sided_Trapezoid_2: "Various Sided Trapezoid 2",
  Various_Sided_Trapezoid_3: "Various Sided Trapezoid 3",
  Various_Sided_Trapezoid_4: "Various Sided Trapezoid 4",
  Quarter_Circle_1: "Quarter Circle 1",
  Quarter_Circle_2: "Quarter Circle 2",
  Quarter_Circle_3: "Quarter Circle 3",
  Quarter_Circle_4: "Quarter Circle 4",
  Quarter_Circle_with_Arc_Adjustment_1: "Quarter Circle with Arc Adjustment 1",
  Quarter_circle_with_arc_adjustment_3: "Quarter circle with arc adjustment 3",
  Quarter_circle_with_arc_adjustment_4: "Quarter circle with arc adjustment 4",
  Bent_triangle_1: "Bent triangle 1",
  Bent_triangle_2: "Bent triangle 2",
  Bent_triangle_3: "Bent triangle 3",
  Bent_triangle_4: "Bent triangle 4",
  Diagonal_triangle_1: "Diagonal triangle 1",
  Diagonal_triangle_2: "Diagonal triangle 2",
  Diagonal_triangle_3: "Diagonal triangle 3",
  Diagonal_triangle_4: "Diagonal triangle 4",
  Right_triangle_1: "Right triangle 1",
  Right_triangle_3: "Right triangle 3",
  Right_triangle_4: "Right triangle 4",
  Cottage_1: "Cottage 1",
  Cottage_2: "Cottage 2",
  Round_cottage_1: "Round cottage 1",
  Round_cottage_2: "Round cottage 2",
  Diagonal_cottage_1: "Diagonal cottage 1",
  Diagonal_cottage_2: "Diagonal cottage 2",
  Diagonal_cottage_3: "Diagonal cottage 3",
  Diagonal_cottage_4: "Diagonal cottage 4",
  Triangle_Equilateral_1: "Triangle Equilateral 1",
  Equilateral_Triangle_2: "Equilateral Triangle 2",
  Equilateral_Triangle_3: "Equilateral Triangle 3",
  Equilateral_Triangle_4: "Equilateral Triangle 4",
  Isosceles_Triangle_1: "Isosceles Triangle 1",
  Isosceles_Triangle_2: "Isosceles Triangle 2",
  Isosceles_Triangle_3: "Isosceles Triangle 3",
  Isosceles_Triangle_4: "Isosceles Triangle 4",
  Parallelogram_1: "Parallelogram 1",
  Parallelogram_2: "Parallelogram 2",
  Parallelogram_3: "Parallelogram 3",
  Parallelogram_4: "Parallelogram 4",
  Segmented_Triangle_1: "Segmented Triangle 1",
  Segmented_Triangle_2: "Segmented Triangle 2",
  Segmented_Triangle_3: "Segmented Triangle 3",
  Segmented_Triangle_4: "Segmented Triangle 4",
  Square_1: "Square 1",
  Square_2: "Square 2",
  Mosque_1: "Mosque 1",
  Mosque_2: "Mosque 2",
  Semicircle_with_adjustment_1: "Semicircle with adjustment 1",
  Semicircle_with_adjustment_2: "Semicircle with adjustment 2",
  Semicircle_with_adjustment_3: "Semicircle with adjustment 3",
  Semicircle_with_adjustment_4: "Semicircle with adjustment 4",
  Semicircle_1: "Semicircle 1",
  Semicircle_2: "Semicircle 2",
  Semicircle_3: "Semicircle 3",
  Semicircle_4: "Semicircle 4",
  Cottage_nine_with_adjustment_1: "Cottage nine with adjustment 1",
  Cottage_nine_with_adjustment_2: "Cottage nine with adjustment 2",
  Cottage_nine_1: "Cottage nine 1",
  Cottage_nine_2: "Cottage nine 2",
  A_bent_corner_1: "A bent corner 1",
  A_bent_corner_2: "A bent corner 2",
  A_bent_corner_3: "A bent corner 3",
  A_bent_corner_4: "A bent corner 4",
  A_diagonal_corner_1: "A diagonal corner 1",
  A_diagonal_corner_2: "A diagonal corner 2",
  A_diagonal_corner_3: "A diagonal corner 3",
  A_diagonal_corner_4: "A diagonal corner 4",

  // todo [some conflict] => [Profile]
  LinedProfile: "Linear profile",
  UnitedProfile: "Unit-based profile",
  profile: "Profile",
  Profile: "Profile",
  isProfile: "Profile",
  profiles: "Profiles",
  chargeProfile: "Profile charge",
  discountProfile: "Profile discount",
  behinehSaziProfile: "Profile optimization",
  statisticProfile: "Profile statistics",

  // todo [some conflict] => [Fitting]
  isFitting: "Fitting",
  fittings: "Fittings",
  chargeFitting: "Fitting charge",
  discountFitting: "Fitting discount",
  Fitting: "Fitting",
  fitting: "Fitting",
  yaragh: "Hardware",
  statisticFitting: "Fitting statistics",

  // todo [some conflict] => [Glass]
  isGlass: "Glass",
  glasses: "Glasses",
  glassName: "Glass name",
  chargeGlass: "Glass charge",
  discountGlass: "Glass discount",
  Glass: "Glass",
  glass: "Glass",
  shishe: "Glass",
  statisticGlass: "Glass statistics",

  // todo [some conflict] => [Net]
  isNet: "Net",
  nets: "Nets",
  chargeNet: "Net charge",
  discountNet: "Net discount",
  Net: "Net",
  net: "Net",
  tori: "Net",
  statisticNet: "Net statistics",

  //! -> [IMPORT] Api-Result-Messages
  Exception: "Software error. Contact support if it persists.",
  MinCountRequestSale: "User count below purchase minimum",
  NotAccessToProject: "No access to this project",
  NotMatchPriceFactor: "Contract amount mismatch",
  largeFile: "File size exceeds limit",
  NotExistContract: "No contract registered for this project",
  TypeFile: "Invalid file type",
  PleaseSale: "Use the purchase service",
  MinTimePeriodExtenstion: "Can extend plan only at period end",
  MinInRange: "Minimum already defined in range",
  MaxInRange: "Maximum already defined in range",
  NotValidFrom: "Invalid start time",
  NotHistoryActive: "No active period in this group",
  ExistOldFactor: "Invoice exists in active period",
  NotEqualRequestWithData: "Requested users less than previous period",
  TicketSupport: "Send a support ticket for this issue",
  TicketClosed: "This ticket is closed. Open a new one if needed.",
  Thickness99: "Blade size support: 99 mm",
  NotAccessLimit: "No permission for this operation (Restricted)",
  Area99: "Area support: 99 m²",
  MaxPieceNotEqualBranch: "Profile piece size exceeds branch length",
  NotExistUserAgent: "Only agents can access this system",
  ChangePhoneNumberTwoFactor: "Cannot change phone & 2FA simultaneously",
  InValidPhone: "Invalid phone number",
  InValidCity: "Invalid city",
  UniqueNameRepeated: "Duplicate unique name",
  InValidRepresentative: "Invalid referral code",
  InvalidToken: "Invalid token",
  InValidEmail: "Invalid email",
  DuplicatePhoneNumber: "Phone number already exists",
  DuplicateEmail: "Email already exists",
  AvataSize70: "Avatar size must be under 70 KB",
  PasswordError: "Incorrect password",
  AvatarERROR: "User avatar save error",
  PhoneNumberConfirmed: "Phone number not verified",
  GiftCardNotValid: "Invalid gift card code",
  GiftCardTime: "Gift card outside valid period",
  GiftCardUsed: "Gift card already used",
  GiftCardTypePeriod: "Gift card for time extension only",
  DistCardNotValid: "Invalid discount card",
  DistCardMinSale: "Minimum purchase required for discount",
  DistCardTime: "Discount card outside valid period",
  DistCardUsed: "Discount card already used",
  DistCardFactorSpecial: "Discount card not applicable to this invoice",
  DistCardLimitSpecial: "Discount card not applicable to this module",
  DistCardProductSpecial: "Discount card not applicable to this product",
  CountProductMin: "At least one product required",
  CountLimitMin: "Minimum required modules not met",
  StandardCountSuperVisor: "Standard supervisor count not maintained",
  CountFactorMin: "At least one invoice required",
  GiftCardMinCount: "This gift card is for promotions",
  NotExistUserGuest: "Only guest users can access this system",
  FactorSysSave: "Cannot save due to report structure",
  InvalidCaptcha: "Invalid captcha",
  Unitfailure: "Save error. Delete and redesign unit.",
  AccessUserFactor: "Error setting user access to invoice. Contact support.",
  AdminUseGroup: "Admin already registered for this group",
  CountPopSysMin: "At least one opener must be active in each system",
  Exeptionsupport: "System error. Contact support.",
  KeyNotCompany: "Invalid company code",
  KeyNotUser: "Invalid user code",
  SystemId: "System ID",
  AccessUserCenter: "Cannot add or define users",
  KeyNotUserRgister: "No user found in this group",
  LockedOut: "Locked out. Retry after 10 minutes.",
  InvalidMobile: "Invalid phone number",
  InvalidEmail: "Invalid email",
  NotGenerateCode: "Validation error",
  ConfrimEmailOld: "Email already verified",
  ConfrimMobileOld: "Mobile number already verified",
  SendTempEmail: "Code sent if email is valid",
  SendTempMobile: "Code sent if mobile is valid",
  NotDeleteCompany: "Cannot delete company with existing groups",
  ExistNameOld: "Name already registered",
  NotExist: "Data not found",
  NotAccess: "Access denied",
  InsertError: "Error saving data",
  UpdateError: "Error updating data",
  RelationDelete: "Cannot delete due to dependencies",
  DeleteError: "Error deleting data",
  NotUpdateField: "Cannot edit system field",
  NotAccessUserRecordAdmin: "Users cannot edit group records",
  NotAccessAdminUserRecord: "Admins cannot edit user records",
  SelectError: "Error retrieving data",
  ErrorRegister: "Error saving user access levels",
  RepeatOrder: "Duplicate priority",
  NotRegisterState: "Specify project status",
  IsLockUnit: "This unit is locked",
  NotRelation: "No relation found",
  NotRelationForDisable: "Item not used. Use delete option.",
  CrossRange: "Opener range conflict",
  AvataSize: "Invalid avatar size",
  ExistUserMobile: "User with this phone exists",
  ExistUserMobileAdmin: "Admin with this phone exists",
  ExistUserEmailAdmin: "Admin with this email exists",
  SuffixEmailBlocked: "Invalid email domain",
  ExistUserRegister: "Username already registered",
  ExistUserEmail: "Email already registered",
  BlockUser: "User is inactive",
  ParameterSelect: "Select parameters",
  OneUnit: "Select at least one unit",
  ExistOld: "Already registered",
  InvalidUser: "Invalid user data",
  ConcurrencyFailure: "Concurrency issue, object modified",
  InvalidKey: "Invalid Code",

  API_ERR_WrongData: "Check submitted data",
  API_ERR_NoInternet: "Check your internet",
  API_ERR_SomeError: "An error occurred",
  API_ERR_ManyReqInSec: "Too many requests",
  API_ERR_ServerErr: "Server error",

  //! -> [IMPORT] Design-Messages
  AccordionDoesNotFit: "Accordion does not fit here",
  ValueNotValid: "Invalid value",
  TypeFrameSlidingMullionNotPlace: "Sliding frame type, mullion not allowed",
  DoseNotIniscriptionMullion: "No inscription mullion for this profile",
  FirstCleanMullions: "Remove mullions before coupling",
  FirstSelectRailModel: "Select rail model first",
  DividerNotFit: "Divider does not fit here",
  TypeFrameOpening: "Hinged frame, sliding system not allowed",
  TechnicallyCheck: "Check technically",
  NotPossibleToPlace: "Placement not possible",
  IsNotPossibleSlidingSystem: "Sliding system not allowed here",
  NotPossibleMoveCouple: "Cannot move couple due to mullion",
  EqualGlassDoesNotWork: "Equal glass not applicable",
  NotPossibleRiser: "Riser cannot be placed",
  HeightNotCorrect: "Incorrect height",
  HeightEnteredLessSizeThreshold: "Height below threshold, adjust",
  ThresholdIsNotPlace: "Threshold cannot be placed",
  NotAppliedPresenceHeightMullions:
    "Height reduction not applied due to mullion",
  AstanaPrerequisiteIsSashProfile: "Threshold needs a sash profile",
  ThreSholdChangeOperation: "Threshold changed successfully",
  MullionIsNotPlace: "Mullion cannot be placed here",
  PartIsNotPlace: "Part is not in a suitable location",
  NotBeChosen: "Invalid selection",
  FittingIsNotDefine: "Opener cannot be placed due to undefined hardware",
  NotValidClickModelRail: "This sliding model is invalid",
  ProfileIsNotDefine:
    "Profile series not defined, system cannot be implemented",
  NotChangeFrameInCombinedSystem: "Frame cannot be changed in combined system",
  PresenceCouplerNotConvert: "Coupler prevents conversion to other frame types",
  CouplerMinimumDistance: "Maintain minimum distance for coupler",
  CoupleDoesNotFail: "Coupler does not fail",
  CoupleDoesNotFitPlace: "Coupler cannot be placed here",
  MullionDoesNotFitPlace: "Mullion cannot be placed here",
  MullionDoesNotFail: "Mullion does not fail",
  MullionMinimumDistance: "Maintain minimum distance for mullion",
  SmallSizeSashNotPlace: "Sash too small to be placed",
  IntersectionLines: "Line intersection error",
  NotPossibleMakeCoupleInSashFrame:
    "Coupling not allowed in sash/rebuild frames",
  MullionInscriptionNotPlace: "Inscription mullion cannot be placed here",
  OpeningIsNotDefinedBrandFitting: "Opener not defined for this brand",
  VolksWagenDoesNotPlace: "Volkswagen opener not allowed here",
  PivotDoesNotPlace: "Pivot cannot be placed",
  SashDoesNotPlace: "Sash cannot be placed",
  FaransaviNotPlace: "French system not allowed here",
  PresenceThreSholdOpeningDoesNotPlace:
    "Opener cannot be placed due to threshold",
  OpeningDoesNotPlace: "Opener cannot be placed here",
  OpeningStandard: "Opener does not match current template",
  FirstCleanInternlalParts: "Remove internal parts first",
  SmallSizeOpeningNotPlace: "Opener too small to place",
  SystemRailOneCouple: "Only one connection allowed in this sliding system",

  // ! ## ## ## ## ## ## ## ## ## ## ## ## Super-Admin-Menu-Items ## ## ## ## ## ##
  sami_pricing: "Pricing",
  sami_support: "Support",
  sami_tickets: "Tickets",
  sami_notices: "Notices",
  sami_financial: "Finance",
  sami_tools: "Special tools",
  sami_statistics: "Statistics",
  customerslist: "Customer list",
  customerName: "Customer name",
  limits: "Limits",
  usersList: "User list",
  periods: "Periods",
  period_details: "Period details",
  infos: "User info",
  details: "Details",
  payByCredit: "Pay with wallet",
  changeAdminStatus: "Activate/Deactivate Super Admin",
  addMoreUser: "Add new user",
  products: "Products",
  supervisor: "Supervisor",
  maxDiscount: "Max discount",
  percentageDiscount: "Percentage discount",
  stepDiscount: "Step discount",
  dayCount: "Days",
  order: "Priority",
  isActive: "Active/Inactive",
  isDefault: "Default/Non-default",
  transactions: "Transactions",
  defaultPanel: "Default panel",
  defaultCharges: "Default charges",
  doFilter: "Apply filter",
  productCount: "Product count",
  priceCredit: "Credit",
  discountCard: "Discount card",
  discountCode: "Discount code",
  incTime: "Increase time",
  incCredit: "Wallet recharge",
  discountValue: "Discount amount",
  minDiscountUsage: "Min purchase amount",
  usageCount: "Usable count",
  refrence: "Reference item",
  stype: "Usage type",
  newIncTime: "Add time to period",
  newIncCredit: "Increase wallet credit",
  stagroup: "User group",
  noData4Send: "No data to send",
  info_userAccountInfo: "Account info",
  info_userAccountRemain: "Remaining subscription time",
  info_countUser: "User count",
  info_credit: "Credit",
  info_jalaliDate: "Date",
  info_jalaliDay: "Day",
  info_period: "Purchased period",
  info_show: "Current status",
  info_show_Extension: "Can extend current period",
  info_show_Sale: "Purchasable",
  info_show_Upgrade: "Can increase users",
  info_Years: "Years",
  info_Months: "Months",
  info_Days: "Days",
  info_RemainDays: "Days until expiration",
  info_Hours: "Hours",
  info_Minutes: "Minutes",
  info_Seconds: "Seconds",
  info_MilliCalc: "Milliseconds",
  enterDashboard: "Enter user dashboard",
  enterDashboardError: "Dashboard access already enabled",
  disabledTransport: "Exit user dashboard",
  sapg_periodsDetail: "Period details",
  sapg_periodsCharge: "Charges",
  sapg_periodsPay: "Payments",
  sapd_payType: "Payment type",
  periodDetailDiscount: "Discount",
  discountModel: "Discount type",
  satpa_num1: "Purchase",
  satpa_num2: "Upgrade",
  satpa_num3: "Free",
  satp_num1: "Wallet",
  satp_num2: "Bank gateway",
  role: "Role",
  IsActiveWithAdminPermisson: "Status (Admin)",
  IsDisableWithSuperAdminPermisson: "Status (Super Admin)",
  normalUserCount: "Regular users",
  nazerUserCount: "Supervised users",
  isCalculate: "Calculating",
  noDataInIncreaseUser: "Enter at least one user value",
  userIncreaseDetails: "User increase details",
  userIncreaseDetailPriceShow: "Payable amount",
  userIncreaseDetailDiscount: "Discount",
  saiu_Limit: "Service",
  saiu_SuperVisor: "Supervisor",
  saiu_Factor: "Invoice",
  saiu_Product: "User",
  change_user_active:
    "Confirm user status change '@USERNAME' from '@NOW' to '@UPDATE'?",
  sali_Name: "Limit name",
  sali_BuyCount: "Purchased count",
  sali_UsedCount: "Used count",
  sali_RequestCount: "Requested count",
  limitsIncreaseDetails: "Limit increase details",
  noDataInIncreaseLimits: "Enter at least one limit value",
  safa_IsActive: "Active in period",
  safa_IsRequest: "To be activated",
  noDataInIncreaseFactors: "No invoice selected for activation",
  factorsIncreaseDetails: "Invoice increase details",
  supervisorTblName: "Supervisor pricing",
  chooseOnePeriod: "Select a period",
  addNewSupervisor: "New supervisor price",
  editSupervisor: "Edit supervisor price",
  deleteSupervisor: "Delete supervisor price",
  serviceTblName: "Service pricing",
  chooseOneService: "Select a service",
  serviceName: "Service name",
  addPriceService: "New service price",
  editPriceService: "Edit service price",
  deletePriceService: "Delete service price",
  productTblName: "Product pricing",
  chooseOneProduct: "Select a product",
  productName: "Product name",
  minCount: "Min",
  maxCount: "Max",
  addPriceProduct: "New product price",
  editPriceProduct: "Edit product price",
  deletePriceProduct: "Delete product price",
  MinCount_EQ_MaxCount: "Max value must be greater than Min",
  factorTblName: "Invoice pricing",
  chooseOneFactor: "Select an invoice",
  factorName: "Invoice name",
  addPriceFactor: "New invoice price",
  editPriceFactor: "Edit invoice price",
  deletePriceFactor: "Delete invoice price",
  periodTblName: "Period pricing",
  addPricePeriod: "New period price",
  editPricePeriod: "Edit period price",
  deletePricePeriod: "Delete period price",
  isActivePeriod: "Active period",
  transactionsTblName: "Transaction list",
  chooseOneGroup: "Select a group",
  checkDate: "Enter valid start & end dates",
  groups: "Groups",
  saaf_JalaliDate: "Date",
  saaf_Type: "Type",
  saaf_Sale: "Sale",
  saaf_Credit: "Credit",
  defaultPanelTblName: "Default panel list",
  safd_Name: "Panel name",
  addDefaultPanel: "New default panel",
  editDefaultPanel: "Edit default panel",
  deleteDefaultPanel: "Delete default panel",
  defaultChargeTblName: "Default charge list",
  addDefaultCharge: "New default charge",
  editDefaultCharge: "Edit default charge",
  deleteDefaultCharge: "Delete default charge",
  discountCardTblName: "Discount card list",
  addDiscountCard: "New discount card",
  editDiscountCard: "Edit discount card",
  deleteDiscountCard: "Delete discount card",
  sadc_Stype: "Type",
  sadc_Refrence: "Item",
  sadc_MinBuy: "Min purchase",
  sadc_UsableCount: "Usable count",
  sadc_CountUsed: "Used count",
  incTimeTblName: "Time increase list",
  sati_UserRegister: "Registered user",
  sati_Inc: "Increase amount",
  sati_GroupId: "Group ID",
  sati_ExpireJalali: "Expiration date",
  group_notice: "Notice type",
  post_type: "Send type",
  notice_reader: "Authorized users",
  notice_delete: "Delete notice",
  notice_add: "New notice",
  sati_IsFree: "Financial status",
  hoursNumber: "Hours",
  freePeriod: "Free",
  nonFreePeriod: "Paid",
  incCreditTblName: "Credit increase list",
  satc_Method: "Method",
  satc_DateJalali: "Date & time",
  satc_Isinc: "Increase",
  statisticTotalProject: "Total project stats",
  statisticTotalYaragh: "Total hardware stats",
  statisticDaily: "Daily stats",
  removeFilter: "Remove filter",
  changeProjects: "Back to project list",
  backToProjectList: "Back to project list",
  select_pattern: "Select a template",
  technical_option: "Remove technical dimension limits",
  default_settings: "Default settings",
  selected_pattern: "Selected template",
  // ! ## ## ## ## ## ## ## ## ## ## ## ## SUPER-ADMIN ## ## ## ## ## ##
};